// File: frontend/src/reducers/sectionsReducer.js

import { 
  FETCH_SECTION_MESSAGES,
  FILTER_SECTION_MESSAGES_BY_CITY
} from '../actions/sectionsActions';

const initialState = {
  messages: [],
  filteredMessages: [],
  selectedCity: null, // 'lyon', 'paris', 'marseille', ou null pour tous
  loading: false,
  error: null
};

function sectionMessagesReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SECTION_MESSAGES:
      return {
        ...state,
        messages: action.payload || [],
        filteredMessages: action.payload || [],
        loading: false,
        error: null
      };

    case FILTER_SECTION_MESSAGES_BY_CITY:
      const city = action.payload;
      const filtered = city 
        ? state.messages.filter(msg => msg.presse === city)
        : state.messages;
      
      return {
        ...state,
        selectedCity: city,
        filteredMessages: filtered
      };

    default:
      return state;
  }
}
export default sectionMessagesReducer;
